import { render, staticRenderFns } from "./add.vue?vue&type=template&id=476b6df7&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('476b6df7')) {
      api.createRecord('476b6df7', component.options)
    } else {
      api.reload('476b6df7', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=476b6df7&", function () {
      api.rerender('476b6df7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/baseInformation/customer/add.vue"
export default component.exports